import { useState } from "react";
import { Document, Page } from "react-pdf"
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { checkIfDomainExists } from "../../../../helpers/helpers";



export const PDFView = ({ url }) => {
    const [numPages, setNumPages] = useState(null)
  console.log("recieved url",url)
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages)
    };
    return (
        <Document file={checkIfDomainExists(url)} onLoadSuccess={onDocumentLoadSuccess} loading={<p className="p-3 font-16 font-weight-700 text-align-center text-default">
            Document is loading, please wait...
        </p>
        }
            noData={<p className="p-3 font-16 font-weight-700 text-align-center text-default">
                Not able to load the document
            </p>}
        >
            {Array.from(new Array(numPages), (doc, idx) => (
                <Page key={idx} pageNumber={idx + 1} />
            ))}
        </Document>
    )
}